import React from 'react';
import GPSSummary from './GPSSummary';
import GPSSecteurs from './GPSSecteurs';
import GPSIssues from './GPSIssues';
import GPSSLAs from './GPSSLAs';
import GPSCosts from './GPSCosts';
import GPSSante from './GPSSante';
import GPSFormsTab from './GPSFormsTab';
import GPSCalendar from './GPSCalendar';
import ErrorBoundary from '../ui/ErrorBoundary';
import GPSMethodology from './GPSMethodology';
import LoadingSpinner from '../../components/LoadingSpinner';
import { useGPS } from '../../contexts/GPSContext';
import { getAdminBadge } from '../../utils/getAdminBadge';

const isAdminUser = (currentUser) => currentUser?.isadmin || currentUser?.issuperadmin;

export const getGPSTabs = (currentUser) => {
  const tabs = [
    {
      id: 'general',
      label: 'Général',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path></svg>
      ),
      content: (
        <div>
          <GPSSummary currentUser={currentUser} />
        </div>
      )
    },
    {
      id: 'secteurs',
      label: 'Secteurs',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9" /></svg>
      ),
      content: (
        <div>
          <GPSSecteurs />
        </div>
      )
    },
    {
      id: 'statuses',
      label: 'Statuts',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
      ),
      content: (
        <div>
          <GPSSLAs />
        </div>
      )
    },
    {
      id: 'issues',
      label: 'Tickets',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 7h18M3 12h18M3 17h18" /></svg>
      ),
      content: (
        <div>
          <GPSIssues />
        </div>
      )
    },
    {
      id: 'forms',
      label: 'Formulaires',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>
      ),
      content: (
        <div>
          <GPSFormsTab currentUser={currentUser} />
        </div>
      )
    },
    {
      id: 'calendrier',
      label: 'Calendrier',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3M3 11h18M5 5h14a2 2 0 012 2v12a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2z" /></svg>
      ),
      content: (
        <div>
          <ErrorBoundary fallback={
            <div className="p-10 text-center text-sm text-gray-500 dark:text-gray-400">
              Le calendrier n'a pas pu s'afficher.
            </div>
          }>
            <GPSCalendar />
          </ErrorBoundary>
        </div>
      )
    },
    {
      id: 'lexicon',
      label: 'Lexique & Définitions',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z" /></svg>
      ),
      content: (
        <div>
          <GPSMethodology />
        </div>
      )
    },
    {
      id: 'health',
      label: <>{getAdminBadge()} Santé</>,
      admin: true,
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 3h4v6h6v4h-6v8h-4v-8H4V9h6V3z" /></svg>
      ),
      content: (
        <div>
          <GPSSante />
        </div>
      )
    },
    {
      id: 'costs',
      label: <>{getAdminBadge()} Coûts</>,
      admin: true,
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 10h12M4 14h10M19 6a7.7 7.7 0 00-5.2-2A7.9 7.9 0 006 12a7.9 7.9 0 007.8 8A7.7 7.7 0 0019 18" /></svg>
      ),
      content: (
        <div>
          <GPSCosts />
        </div>
      )
    }
  ];

  return tabs.filter(tab => !tab.admin || isAdminUser(currentUser));
};

const GPSTabs = ({ active = 'general', currentUser }) => {
  const gps = useGPS();
  const tabs = getGPSTabs(currentUser);

  const activeContent = tabs.find(t => t.id === active)?.content || tabs[0]?.content || null;

  return (
    <div className="rounded-lg">
      <div className="sm:p-0">
        {gps.issuesLoading ? (
          <div className="flex justify-center my-8">
            <LoadingSpinner />
          </div>
        ) : (
          activeContent
        )}
      </div>
    </div>
  );
};

export default GPSTabs;
